// extracted by mini-css-extract-plugin
export var active = "CalculatorWithTabs-module--active--11b63";
export var button = "CalculatorWithTabs-module--button--b6365";
export var calculator = "CalculatorWithTabs-module--calculator--e713d";
export var fadeInAnimation = "CalculatorWithTabs-module--fadeInAnimation--f1475";
export var tabsRow = "CalculatorWithTabs-module--tabsRow--9565c";
export var wrapper = "CalculatorWithTabs-module--wrapper--d5303";